import * as z from "zod";

export enum ProcessorHistoryItemKind {
  RETURN_ITEM = "return",
  ITEM_SESSION = "item",
}

export const processorHistoryItemSchema = z.object({
  id: z.string(),
  processorUserId: z.string(),
  kind: z.enum(ProcessorHistoryItemKind),
  title: z.string().nullable(),
  variantTitle: z.string().nullable(),
  sku: z.string().nullable(),
  imageUrl: z.string().nullable(),
  merchantTeamId: z.string().nullable(),
  merchantName: z.string().nullable(),
  returnId: z.string().nullable(),
  grade: z.string().nullable(),
  outcome: z.string().nullable(),
  /** `null` when no event marks when work on the item began. */
  startedAt: z.date().nullable(),
  completedAt: z.date(),
});

export const getProcessorHistory = {
  name: "getProcessorHistory" as const,
  input: z.object({
    userId: z.string().regex(/^[0-9a-f]{24}$/),
    startDate: z.date(),
    endDate: z.date(),
    returnsCenterId: z.string().optional(),
    teamIds: z.array(z.string()).optional(),
  }),
  output: z.object({
    /** Oldest first. */
    items: z.array(processorHistoryItemSchema),
    truncated: z.boolean(),
  }),
};

export type ProcessorHistory = z.infer<(typeof getProcessorHistory)["output"]>;
export type ProcessorHistoryItem = z.infer<typeof processorHistoryItemSchema>;
